import { ContractorType } from './ContractorType'
import { EditVehicle } from './EditVehicle'
import { FiftyFiftyFull } from './FiftyFiftyFull'
import { Franchise } from './Franchise'
import { InsuranceAmount } from './InsuranceAmount'
import { InsurancePackage } from './InsurancePackage'
import { ValidFrom } from './ValidFrom'

export const MainStep = () => {
  return (
    <>
      <ContractorType />
      <InsurancePackage />
      <FiftyFiftyFull />
      <InsuranceAmount />
      <ValidFrom />
      <EditVehicle />
      <Franchise />
    </>
  )
}
